<template>
	<div class="text-center">
		<a href="javascript:void(0);" @click="changeLocale('kh')">
			<img src="/flag/kh.png" style="height: 20px;"/>
			ភាសាខ្មែរ
		</a>
		<span style="font-family: Helvetica;">&nbsp;</span>
		<a href="javascript:void(0);" @click="changeLocale('en')">
			<img src="/flag/en.png" style="height: 20px;"/>
			English
		</a>
	</div>
</template>

<script>
export default {
	name: "LinkLocaleChanger",
	methods: {
		changeLocale(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem("locale", locale);
		}
	}
};
</script>